import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Login from '@/components/Login'
import ForgotPassword from '@/components/ForgotPassword'
import Register from '@/components/Register'
import User from '@/components/User'
import Shop from '@/components/Shop'
import Cart from '@/components/Cart'
import Order from '@/components/Order'
import Book from '@/components/Book'
import BookAudio from '@/components/BookAudio'
import qs from 'querystring'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/book',
      name: 'Book',
      component: Book,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/mp3',
      name: 'BookAudio',
      component: BookAudio,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: {
        mounted () {
          this.$store.dispatch('logout')
            .then(() => {
              this.$router.push('/')
            })
        }
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/forgot_password',
      name: 'Forgot Password',
      component: ForgotPassword,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/shop',
      name: 'Shop',
      component: Shop,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      children: [
        { path: '', component: require('../components/MyProfile') },
        { path: 'profile', component: require('../components/MyProfile') },
        { path: 'password', component: require('../components/MyPassword') },
        { path: 'period', component: require('../components/MyPeriod') },
        { path: 'coin', component: require('../components/MyCoins') }
      ],
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order',
      name: 'Order',
      component: Order,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/learning',
      name: 'Learning',
      component: {
        mounted () {
          window.open('https://learning.abcplay.com.tw/sitelogin_fast?' + qs.stringify({
            'userid': this.$store.getters.user.UserName,
            'tokenguid': window.localStorage.getItem('token'),
            'websiteurl': 'ilearning.liveabc.com'
          }))
        }
      },
      meta: {
        requiresAuth: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js